import React from 'react';
import { Sprite } from '@ktag/styleguide/dist/react';
import { Attribute } from 'jobs.types';

interface Props {
  value: Attribute;
}

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};

const AdminViewTab = ({ value }: Props) => {
  const filteredValues = value.values.filter((v) => v.id !== '0');

  filteredValues.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <table className="adminview__table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
        </tr>
      </thead>
      <tbody>
        {filteredValues.map((v) => (
          <tr key={v.id}>
            <td className="adminview__cell-id">
              {v.id}
              <Sprite
                id="copy"
                onClick={() => copyToClipboard(v.id)}
                additionalClassNames="adminview__copy-icon"
              />
            </td>
            <td className="adminview__cell-name">{v.name}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AdminViewTab;
